import Vue from 'vue';

// TODO: find another way for registering global components. This automatic way doesn't work in a production build
// (function init() {
//   const vueComponentsInFolder = require.context('./', true, /\.vue$/);
//   vueComponentsInFolder
//     .keys()
//     .map((key) => vueComponentsInFolder(key))
//     .map((module) => {
//       const vueComponent = module.default as VueConstructor;
//       const componentName = vueComponent.name;
//       Vue.component(componentName, vueComponent);
//     });
// })();

import Button from './Button.vue';
import LinkButton from './LinkButton.vue';
import RouterLinkButton from './RouterLinkButton.vue';
import SvgIcon from './SvgIcon.vue';
import LoadingOverlay from './LoadingOverlay.vue';

Vue.component('BucpButton', Button);
Vue.component('LinkButton', LinkButton);
Vue.component('RouterLinkButton', RouterLinkButton);
Vue.component('SvgIcon', SvgIcon);
Vue.component('LoadingOverlay', LoadingOverlay);
